exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-data-field\r\n{\r\n    direction: ltr;\r\n    text-align: right;\r\n}\r\n.div-btn-login\r\n{\r\n    width: 70%;\r\n}\r\n.div-btn-startover\r\n{\r\n    width: 20%;\r\n}\r\n.otp-error\r\n{\r\n    color: red;\r\n}\r\n.otp-message\r\n{\r\n    color: green;\r\n}\r\n.phone-masked\r\n{\r\n    margin-right: 10px;\r\n    direction: ltr;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/user/sign-in/sign-in.component.css
// module id = ../../../../../src/app/user/sign-in/sign-in.component.css
// module chunks = main